<template>
    <!-- 下拉框组件 -->
    <el-select 
    v-model="value" 
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :filterable="filterable"
    :filter-method="filterFn"
    :remote="remote"
    :remote-method="remoteFn"
    :default-first-option="firstoption"
    :allow-create="create"
    :value-key="valueKey"
    :multiple-limit="limit"
    :autocomplete="autocomplete"
    :name="name"
    :loading-text="loadingText"
    :reserve-keyword="reservekeyword"
    :automatic-dropdown="autodropdown"
    :size="size"
    @focus="focus"
    @clear="clear"
    @change="change"
    @blur="blur"
    @remove-tag="removeTag"
    >   
        <!-- 前置图标插槽 -->
        <template v-slot:prefix>
            <slot name="beforeIcon"></slot>
        </template>
        <!-- 组 -->
        <template v-if="isGroup">
            <el-option-group
            v-for="(group,ginx) in selectList"
            :key="group.label + ginx"
            :label="group.label">
                <template>
                    <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    >
                        <!-- option插槽 -->
                        <slot></slot>
                    </el-option>
                </template>
            </el-option-group>
        </template>
        <!-- 单个 -->
        <template v-else>
            <el-option
            v-for="(item,index) in selectList"
            :key="item.value + index"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
            :size="size"
            >   
                <!-- option插槽 -->
                <slot></slot>
            </el-option>
        </template>
    </el-select>
</template>
<script>
export default {
    name:"VelSelect",
    props:{
        initValue:[String,Boolean,Number],
        size:String,
        placeholder:String,
        filterFn:Function,
        remoteFn:Function,
        valueKey:String,
        size:String,
        limit:Number,
        autocomplete:String,
        name:String,
        loadingText:String,
        selectList:{
            type:Array,
            requreid:true
        },
        isClearable:Boolean,
        isMultiple:Boolean,
        isCollapseTags:Boolean,
        isFilter:Boolean,
        isReKeyword:Boolean,
        isAutodropdown:Boolean,
        isRemote:Boolean,
        isFirstoption:Boolean,
        isCreate:Boolean,
        isDisable:Boolean,
    },
    data() {
        return {
            value:'',
            isGroup:false,
            clearable:true,
            multiple:false,
            collapseTags:false,
            filterable:false,
            reservekeyword:false,
            autodropdown:false,
            remote:false,
            firstoption:false,
            create:false,
            disabled:false,
        };
    },
    created() {
        // this.getValue()
        this.initDataFn()
        this.isGroupFn(this.selectList)
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        initDataFn(){
            this.isClearable ? this.clearable = false : this.clearable
            this.isMultiple ? this.multiple = true : this.multiple
            this.isCollapseTags ? this.collapseTags = true : this.collapseTags
            this.isFilter ? this.filterable = true : this.filterable
            this.isReKeyword ? this.reservekeyword = true : this.reservekeyword
            this.isAutodropdown ? this.autodropdown = true : this.autodropdown
            this.isRemote ? this.remote = true : this.remote
            this.isFirstoption ? this.firstoption = true : this.firstoption
            this.isCreate ? this.create = true : this.create
            this.isDisable ? this.disabled = true : this.disabled
        },
        isGroupFn(arr){
            if(!arr) return false
            arr.forEach(item =>{
                if(item.options){
                    this.isGroup = true
                }
            })
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = this.selectList[0].value
        },
        focus(){
            this.$emit('focus')
        },
        change(val){
            this.$emit('change',val)
        },
        blur(){
            this.$emit('blur')
        },
        clear(){
            this.$emit('clear')
        },
        removeTag(e){
            this.$emit('removeTag',e)
        }
    }
}
</script>